import { faList } from "@fortawesome/pro-solid-svg-icons"

import IconLink from "../../components/IconLink"
import Sidebar from "../../components/Sidebar"
import BecomeAMemberOverlay from "../../components/BecomeAMemberOverlay"
import { ProgramType } from "@/types/program"

export interface StackablesProps {
  stackablePrograms: ProgramType[]
  isMultiAccount: boolean
  accountId: string
  isMember: boolean | undefined
}

const Stackables = ({
  stackablePrograms,
  isMultiAccount,
  accountId,
  isMember,
}: StackablesProps) => {
  if (!stackablePrograms || stackablePrograms?.length === 0) {
    return null
  }

  return (
    <Sidebar
      title="Stackable programs"
      className="relative mb-6 stackables-section"
      description="Stackables are programs that you can participate in at the same time as this program."
    >
      {stackablePrograms?.map((program) => (
        <IconLink
          key={program.id}
          to={
            isMultiAccount
              ? `/accounts/${accountId}/programs/${program.id}`
              : `/programs/${program.id}`
          }
          icon={faList}
          text={program.name}
          className="truncate mb-3 stackable-program-link"
        />
      ))}

      <BecomeAMemberOverlay show={!isMember} absolute isSidebar />
    </Sidebar>
  )
}

export default Stackables
